import { fields, resolve, typeLabel } from '../../lib/schema.js'

const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- api-schema ---
let __fez_component_0;
{
function objectOf(schema, defs) {
  let { schema: s } = resolve(schema, defs)
  if (s.type === 'array' && s.items) s = resolve(s.items, defs).schema
  return s.properties || s.allOf ? s : null
}
__fez_component_0 = class {
  PROPS = {
    schema: Object,
    defs: Object,
    depth: { type: Number, default: 0 },
  }

  beforeRender() {
    const defs = this.props.defs
    this.state.rows = fields(this.props.schema, defs).map((row) => ({
      ...row,
      child: this.props.depth < 4 ? objectOf(row.schema, defs) : null,
    }))
    this.state.type = typeLabel(this.props.schema, defs)
  }

  CSS = `:fez {
display:block;ul{margin:0;padding:0;list-style:none}li{padding:var(--space-3) 0;& + li{border-top:1px solid var(--color-border)}}.line{display:flex;flex-wrap:wrap;align-items:baseline;gap:var(--space-2)}.name{color:var(--color-text);font-family:var(--font-mono);font-size:var(--text-sm);font-weight:var(--weight-semibold)}.type{color:var(--color-link);font-family:var(--font-mono);font-size:var(--text-xs)}.required{color:var(--color-danger);font-size:var(--text-xs);font-weight:var(--weight-semibold)}.optional{color:var(--color-text-subtle);font-size:var(--text-xs)}.desc{margin-top:2px;color:var(--color-text-muted);font-size:var(--text-sm)}.notes{display:flex;flex-wrap:wrap;gap:var(--space-1);margin-top:var(--space-1)}.nested{margin-top:var(--space-2);padding-left:var(--space-4);border-left:2px solid var(--color-border)}.scalar{color:var(--color-text-muted);font-size:var(--text-sm);code{color:var(--color-link)}}
}`

  HTML = `{#if state.rows.length}
<ul>
{#each state.rows as row}
<li>
<div class="line">
<span class="name">{row.name}</span>
<span class="type">{row.type}{row.nullable ? ' | null' : ''}</span>
{#if row.required}
<span class="required">required</span>
{:else}
<span class="optional">optional</span>
{/if}
</div>
{#if row.description}
<div class="desc">{row.description}</div>
{/if}
{#if row.notes.length}
<div class="notes">
{#each row.notes as note}
<ui-badge label={note}></ui-badge>
{/each}
</div>
{/if}
{#if row.child}
<div class="nested">
<api-schema :schema="row.child" :defs="props.defs" depth={props.depth + 1}></api-schema>
</div>
{/if}
</li>
{/each}
</ul>
{:else}
<p class="scalar">Returns <code>{state.type === 'null' ? 'null' : state.type}</code>.</p>
{/if}`
};
}

Fez('api-schema', __fez_component_0);

export default __fez_component_0;
